export default __webpack_public_path__ + "crossModal809536.png";